import {createTheme} from '@mui/material/styles';
import {deepmerge} from '@mui/utils';

import MuiInputThemeComponents from '@/themes/mui/components/MuiInputThemeComponents';
import MuiSelectThemeComponents from '@/themes/mui/components/MuiSelectThemeComponents';

const MuiSelectTheme = function () {
    let mergedTheme = deepmerge(MuiInputThemeComponents, MuiSelectThemeComponents);

    return createTheme(mergedTheme);
};

export default MuiSelectTheme;
